// src/components/PaymentBlockModal/PaymentBlockModal.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaLock, FaCreditCard } from 'react-icons/fa';
import useBillingStore from '../../services/useBillingStore';
import './PaymentBlockModal.css';

/**
 * Modal que aparece quando o usuário tenta fazer uma ação
 * que requer pagamento (adicionar lead, criar integração, etc.)
 */
const PaymentBlockModal = ({ isOpen, onClose, actionName = "esta ação" }) => {
  const { subscription } = useBillingStore();

  const handleGoToCheckout = () => {
    if (subscription?.checkout_url) {
      window.open(subscription.checkout_url, '_blank');
    }
    onClose();
  };

  // Não renderiza nada se o modal está fechado
  // Importante: Esta verificação DEVE estar fora do AnimatePresence
  // para evitar conflitos de remoção DOM com React 19
  if (!isOpen) {
    return null;
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key="payment-block-overlay"
        className="payment-block-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          key="payment-block-content"
          className="payment-block-modal"
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{ type: 'spring', duration: 0.4 }}
          onClick={(e) => e.stopPropagation()}
        >
            {/* Icone de bloqueio */}
            <div className="payment-block-icon">
              <FaLock />
            </div>

            {/* Titulo */}
            <h3 className="payment-block-title">
              Ação Bloqueada
            </h3>

            {/* Mensagem */}
            <p className="payment-block-message">
              Para {actionName}, você precisa ativar seu plano.
              <br />
              <span className="payment-block-highlight">
                Finalize o pagamento para liberar todas as funcionalidades.
              </span>
            </p>

            {/* Botões */}
            <div className="payment-block-buttons">
              <button
                className="payment-block-btn-primary"
                onClick={handleGoToCheckout}
              >
                <FaCreditCard />
                Ativar Plano Agora
              </button>

              <button
                className="payment-block-btn-secondary"
                onClick={onClose}
              >
                Continuar Explorando
              </button>
            </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PaymentBlockModal;
